import { Getters } from 'vuex-smart-module';
import NewsState from './state';

export default class NewsGetters extends Getters<NewsState> {}
